import { SET_IMAGE_START, SET_IMAGES } from '../actions';

const initialState = {
    fetched: false,
    failed: false,
    images: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_IMAGE_START:
            return { ...state, fetched: false, images: [] };
        case SET_IMAGES:
            return {
                ...state,
                fetched: true,
                images: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/postImage_reducer.jsx